module.exports = __webpack_public_path__ + "img/2-4.476f8644.svg";